export default "<p>about-us works!</p>\r\n"